import StudentProjectCard from '@components/common/student-project-card'
import { STUDENT_PROJECTS } from '@lib/data/student-projects'
import { useRef } from 'react'
import { ProjectVideoCardRefType } from '@lib/types/student-project'

const IMAGE_PATH = '/images/student-projects-page/project-images/'
const Projects = () => {
  const projectVideoCardRefs: ProjectVideoCardRefType = STUDENT_PROJECTS.map(
    () => useRef<HTMLVideoElement>()
  )
  return (
    <div className="container mx-auto relative z-10 mb-12 md:mb-20">
      <h3 className="text-grey-900 text-center text-3xl font-700 pt-16 px-2 pb-5">
        Featured projects
      </h3>
      <p className="text-grey-900 text-center px-4 md:px-48 text-lg pb-5">
        Our students use their learnings to create amazing projects ranging from
        exciting games and applications to complex websites. Here are a few to
        inspire you.
      </p>
      <div className="relative grid md:grid-cols-3 justify-center gap-8 my-4 mx-4">
        {STUDENT_PROJECTS.map((project, index) => (
          <StudentProjectCard
            key={project.projectName}
            project={project}
            IMAGE_PATH={IMAGE_PATH}
            projectVideoCardRef={projectVideoCardRefs[index]}
          />
        ))}
      </div>
    </div>
  )
}

export default Projects
